import { render, staticRenderFns } from "./MusicPanel.vue?vue&type=template&id=39914485&scoped=true&"
import script from "./MusicPanel.vue?vue&type=script&lang=js&"
export * from "./MusicPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39914485",
  null
  
)

export default component.exports